/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RichiesteTimbratureApprovazioniStoricoDTO
 */
export interface RichiesteTimbratureApprovazioniStoricoDTO {
    /**
     * 
     * @type {number}
     * @memberof RichiesteTimbratureApprovazioniStoricoDTO
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof RichiesteTimbratureApprovazioniStoricoDTO
     */
    idRichiedente?: number;
    /**
     * 
     * @type {string}
     * @memberof RichiesteTimbratureApprovazioniStoricoDTO
     */
    richiedente?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RichiesteTimbratureApprovazioniStoricoDTO
     */
    dataRichiesta?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RichiesteTimbratureApprovazioniStoricoDTO
     */
    data?: Date;
    /**
     * 
     * @type {string}
     * @memberof RichiesteTimbratureApprovazioniStoricoDTO
     */
    tipo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RichiesteTimbratureApprovazioniStoricoDTO
     */
    causale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RichiesteTimbratureApprovazioniStoricoDTO
     */
    note?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RichiesteTimbratureApprovazioniStoricoDTO
     */
    isDeletable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RichiesteTimbratureApprovazioniStoricoDTO
     */
    approvazione?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RichiesteTimbratureApprovazioniStoricoDTO
     */
    approvatore?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RichiesteTimbratureApprovazioniStoricoDTO
     */
    primoApprovatore?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RichiesteTimbratureApprovazioniStoricoDTO
     */
    secondoApprovatore?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RichiesteTimbratureApprovazioniStoricoDTO
     */
    approvatoIl?: Date | null;
}

/**
 * Check if a given object implements the RichiesteTimbratureApprovazioniStoricoDTO interface.
 */
export function instanceOfRichiesteTimbratureApprovazioniStoricoDTO(value: object): value is RichiesteTimbratureApprovazioniStoricoDTO {
    return true;
}

export function RichiesteTimbratureApprovazioniStoricoDTOFromJSON(json: any): RichiesteTimbratureApprovazioniStoricoDTO {
    return RichiesteTimbratureApprovazioniStoricoDTOFromJSONTyped(json, false);
}

export function RichiesteTimbratureApprovazioniStoricoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RichiesteTimbratureApprovazioniStoricoDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'idRichiedente': json['idRichiedente'] == null ? undefined : json['idRichiedente'],
        'richiedente': json['richiedente'] == null ? undefined : json['richiedente'],
        'dataRichiesta': json['dataRichiesta'] == null ? undefined : (new Date(json['dataRichiesta'])),
        'data': json['data'] == null ? undefined : (new Date(json['data'])),
        'tipo': json['tipo'] == null ? undefined : json['tipo'],
        'causale': json['causale'] == null ? undefined : json['causale'],
        'note': json['note'] == null ? undefined : json['note'],
        'isDeletable': json['isDeletable'] == null ? undefined : json['isDeletable'],
        'approvazione': json['approvazione'] == null ? undefined : json['approvazione'],
        'approvatore': json['approvatore'] == null ? undefined : json['approvatore'],
        'primoApprovatore': json['primoApprovatore'] == null ? undefined : json['primoApprovatore'],
        'secondoApprovatore': json['secondoApprovatore'] == null ? undefined : json['secondoApprovatore'],
        'approvatoIl': json['approvatoIl'] == null ? undefined : (new Date(json['approvatoIl'])),
    };
}

export function RichiesteTimbratureApprovazioniStoricoDTOToJSON(json: any): RichiesteTimbratureApprovazioniStoricoDTO {
    return RichiesteTimbratureApprovazioniStoricoDTOToJSONTyped(json, false);
}

export function RichiesteTimbratureApprovazioniStoricoDTOToJSONTyped(value?: Omit<RichiesteTimbratureApprovazioniStoricoDTO, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idRichiedente': value['idRichiedente'],
        'richiedente': value['richiedente'],
        'dataRichiesta': value['dataRichiesta'] == null ? undefined : ((value['dataRichiesta']).toISOString()),
        'data': value['data'] == null ? undefined : ((value['data']).toISOString()),
        'tipo': value['tipo'],
        'causale': value['causale'],
        'note': value['note'],
        'isDeletable': value['isDeletable'],
        'approvazione': value['approvazione'],
        'approvatore': value['approvatore'],
        'primoApprovatore': value['primoApprovatore'],
        'secondoApprovatore': value['secondoApprovatore'],
        'approvatoIl': value['approvatoIl'] == null ? undefined : ((value['approvatoIl'] as any).toISOString()),
    };
}

